import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proceso-finalizado',
  templateUrl: './proceso-finalizado.component.html',
  styleUrls: ['./proceso-finalizado.component.css']
})
export class ProcesoFinalizadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
